import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { generalAudioCaching } from '../../misc/tools';

import "./button2.css"

const Button2 = (props: Button2Config) => {
	const [isHovering, setIsHovering] = useState(false)
	return (
		<div className={"main-content-inner button-container"+ (props.isSelected ? ' btn-selected' : '')} tabIndex={(props.isDisabled ? -1 : 0)} aria-label={props.ariaLabel} style={{
			width: props.width,
			cursor: 'pointer',
			height: props.height,
			position: 'relative',
			opacity: props.isDisabled && props.updateDisableOpacity ? 0.5 : 1,
			backgroundColor: props.isSelected ? 'white' : (isHovering ? (props.hoverBgColor ?? props.backgroundColor) : props.backgroundColor),
			color: props.isSelected ? 'rgb(55, 70, 104)' : (props.backgroundColor ? 'white' : 'black'),
			pointerEvents: props.isDisabled ? 'none' : 'all',
			...props.style
        }} onMouseEnter={() => {
            setIsHovering(true);
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
			Tools.playOneShotSound(url);
		}} onMouseLeave={() => {
            setIsHovering(false);
		}} onKeyUp={Tools.mapDivEnterToClick} data-testid="test-button-2" onClick={() => {
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.digi_plink_01).src;
			Tools.playOneShotSound(url);
			if(props.onClick) {
				props.onClick()
			}
		}} id={props.idFor508}>
			{props.onRenderContent(isHovering)}
		</div>
	);
};

export interface Button2Config {
	onClick: () => void;
	idFor508?: string;
	onRenderContent: (isHovering?: boolean) => any;
	backgroundColor?: string;
	ariaLabel: string;
	width: string;
	style?: any;
	height: string;
	isSelected?: boolean;
	isDisabled?: boolean;
    hoverBgColor?: string;
    updateDisableOpacity?: boolean;
}

export default Button2;